export type Filter = 'new' | 'replied' | 'no reply' | 'mobile' | 'landline';

export const buildHQLQueryFromFilters = (filters: Filter[]): string => {
  if (!Array.isArray(filters) || !filters.length) {
    return '';
  }

  let qs = '';
  filters.forEach((filter, index) => {
    let newFilter = '';

    switch (filter) {
      case 'new':
        newFilter = 'campaign NEVER OCCURRED';
        break;
      case 'replied':
        newFilter = 'campaign:"Status" EQUALS "replied"';
        break;
      case 'no reply':
        newFilter =
          'campaign:"Status" DOES NOT EQUAL "replied" AND campaign OCCURRED';
        break;
      case 'mobile':
        newFilter = 'phoneType EQUALS "mobile"';
        break;
      case 'landline':
        newFilter = 'phoneType EQUALS "landline"';
        break;
      default:
        break;
    }

    qs = `${qs}${index !== 0 ? ' AND ' : ''}${newFilter}`;
  });

  return qs;
};
